import type { CONSTS } from 'config/objectConst'

import TableCell from '@mui/material/TableCell'
import lock from 'assets/image/icons/svg/lock.svg'
import clsx from 'clsx'
import { InformationalTip } from 'components/molecules/InformationalTip/InformationalTip'

import type { Campaign, PauseReason, State } from '../../types'

const pauseReasonToTip: Partial<Record<PauseReason, keyof typeof CONSTS.TIPS>> =
	{
		ExceedFreeMonthlyPersonalizedInvitations: 'n4.1',
		TooLongInvitationMessage: 'n4.2'
	}

const stopPropagation = (e: Pick<MouseEvent, 'stopPropagation'>) =>
	e.stopPropagation()

const stateToCN: Record<State, string> = {
	Completed: 'completed',
	Compose: 'drafted',
	Running: 'active',
	Stopped: 'paused'
}

const SimpleFlow = ({ state }: Pick<Campaign, 'state'>) => (
	<div className={clsx('status', stateToCN[state])}>{stateToCN[state]}</div>
)

export function AccentFlow({
	id,
	pause_reason: pauseReason,
	state
}: Pick<Campaign, 'id' | 'pause_reason' | 'state'>) {
	const className = clsx('status-accent', stateToCN[state])

	const tipKey = pauseReasonToTip[pauseReason]

	const withToolTip =
		pauseReason === 'ExceedFreeMonthlyPersonalizedInvitations' ||
		pauseReason === 'TooLongInvitationMessage'

	const anchorCN = InformationalTip.useAnchorClass(id)

	if (state === 'Stopped') {
		return (
			<div className={className}>
				{stateToCN[state]}{' '}
				{withToolTip && (
					<img
						alt='iconStop'
						className={clsx(anchorCN, 'clock-icon')}
						data-id={id}
						onClick={event => {
							const anchor = event.currentTarget

							tipKey && InformationalTip.open(tipKey, anchor)
						}}
						src={lock}
					/>
				)}
			</div>
		)
	}

	return <div className={className}>{stateToCN[state]}</div>
}

export function StatusCell({
	actions,
	id,
	pause_reason,
	state
}: Campaign & {
	activeId?: string
}) {
	const isArchived = actions.unarchive.enabled

	const isBlockRedirect =
		!isArchived &&
		(pause_reason === 'ExceedFreeMonthlyPersonalizedInvitations' ||
			pause_reason === 'TooLongInvitationMessage')

	return (
		<TableCell
			className={clsx('contacts', !isArchived && 'flex-container')}
			onClick={isBlockRedirect ? stopPropagation : undefined}
			style={{ width: '10%' }}
		>
			{isArchived ? (
				<SimpleFlow state={state} />
			) : (
				<AccentFlow id={id} pause_reason={pause_reason} state={state} />
			)}
		</TableCell>
	)
}
